export default __webpack_public_path__ + "static/media/330_dummy2016-coach01-de.9902f9f2.png";